export default __webpack_public_path__ + "static/media/letterheadHero.6c4d6cfa.jpg";